<app-loading *ngIf="isLoading"></app-loading>
<div class="m-5 mainContentDetails">
  <!--For Bank Account Details-->
  <ng-container *ngIf="bankACDetails">
    <div class="row">
      <div class="col-6">
        <p class="titleFont">
          {{ "processClaims.assessment.bankDetails.payoutOptions" | translate }}
        </p>
      </div>
    </div>
    <div class="detail-container card mt-3 p-4">
      <!--Cheque Details-->
      <div class="mt-3">
        <div fxLayout="row wrap" fxLayoutGap="40px grid">
          <div fxFlex="5%" fxFlex.sm="10%" fxFlex.xs="10%">
            <dxc-checkbox
              [checked]="outSourceChequeFlag"
              (onChange)="onDataInput($event, 'O')"
              [value]="paymentTypeDetails.paymentTypeKey"
            ></dxc-checkbox>
          </div>
          <div fxFlex="25%" fxFlex.sm="90%" fxFlex.xs="90%">
            <p class="subTitleFont">
              {{
                "processClaims.assessment.bankDetails.outSourceCheque"
                  | translate
              }}
            </p>
          </div>
          <div fxFlex="5%" fxFlex.sm="10%" fxFlex.xs="10%">
            <dxc-checkbox
              [checked]="preDefinedChequeFlag"
              (onChange)="onDataInput($event, 'P')"
              [value]="paymentTypeDetails.paymentTypeKey"
            ></dxc-checkbox>
          </div>
          <div fxFlex="25%" fxFlex.sm="90%" fxFlex.xs="90%">
            <p class="subTitleFont">
              {{
                "processClaims.assessment.bankDetails.preDefinedCheque"
                  | translate
              }}
            </p>
          </div>
        </div>
      </div>
      <!--Pay Now Details-->
      <div class="mt-3">
        <div fxLayout="row wrap" fxLayoutGap="40px grid">
          <div fxFlex="5%" fxFlex.sm="5%" fxFlex.xs="100%">
            <dxc-checkbox></dxc-checkbox>
          </div>
          <div fxFlex="95%" fxFlex.sm="90%" fxFlex.xs="100%">
            <div class="row">
              <div class="col-6">
                <p class="subTitleFont">
                  {{
                    "processClaims.assessment.bankDetails.payNowDetails"
                      | translate
                  }}
                </p>
              </div>
            </div>
            <!--Content-->
            <div class="listDetails contentFont">
              <ul>
                <li>
                  <!-- <div class="bullet"></div> -->
                  <div class="item-details">
                    <p>
                      PayNow account registered with mobile number will not be
                      eligible.
                    </p>
                    <p>
                      (note: You may register or add your Singapore NRIC/FIN to
                      the PayNow account via the "Manager PayNow" in your
                      internet banking account)
                    </p>
                  </div>
                </li>
                <li>
                  <!-- <div class="bullet"></div> -->
                  <div class="item-details">
                    <p>
                      If PayNow transaction is unsuccessfull, we will send a
                      cheque to your mailing address as per our record.
                    </p>
                  </div>
                </li>
                <li>
                  <!-- <div class="bullet"></div> -->
                  <div class="item-details">
                    <p>
                      PayNow is applicable only for payout upto $200,000 to the
                      policy owner's Singapore bank account.
                    </p>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <!--Bank Account Details-->
      <div class="mt-3">
        <div fxLayout="row wrap" fxLayoutGap="40px grid">
          <div fxFlex="5%" fxFlex.sm="5%" fxFlex.xs="100%">
            <dxc-checkbox
              [checked]="bankAccountDetailsFlag"
              (onChange)="onDataInput($event, 'D')"
              [value]="paymentTypeDetails.paymentTypeKey"
            ></dxc-checkbox>
          </div>
          <div fxFlex="95%" fxFlex.sm="90%" fxFlex.xs="100%">
            <div class="row">
              <div class="col-6">
                <p class="subTitleFont">
                  {{
                    "processClaims.assessment.bankDetails.bankAccountDetails"
                      | translate
                  }}
                </p>
              </div>
            </div>
            <!--Content-->
            <div>
              <p class="contentFont">
                {{
                  "processClaims.assessment.bankDetails.content1" | translate
                }}
              </p>
            </div>
            <!--Form-->
            <div class="row">
              <!--Bank Acc No-->
              <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12">
                <custom-input-text
                  label="{{
                    'processClaims.assessment.bankDetails.bankAccountNumber'
                      | translate
                  }}"
                ></custom-input-text>
              </div>
              <!--Bank Name-->
              <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12">
                <custom-input-text
                  label="{{
                    'processClaims.assessment.bankDetails.bankName' | translate
                  }}"
                ></custom-input-text>
              </div>
              <!-- Add Bank Details Button-->
              <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12">
                <custom-button
                  class="addButton"
                  label="{{
                    'processClaims.assessment.bankDetails.bankAccDetails'
                      | translate
                  }}"
                  mode="secondary"
                  [iconSrc]="addIcon"
                  iconPosition="after"
                  (onClick)="openBankDetails()"
                >
                </custom-button>
              </div>
            </div>
            <!--Content-->
            <div>
              <p class="contentFont">
                {{
                  "processClaims.assessment.bankDetails.content2" | translate
                }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row mt-5">
      <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 mobAction text-right">
        <custom-button
          label="{{
            'claimOffice.beneficiariesRequirement.requirements.save' | translate
          }}"
          margin="xxsmall"
          mode="primary"
          (onClick)="onSavePaymentType()"
        >
        </custom-button>
      </div>
      <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 mobAction text-left">
        <custom-button
          label="{{
            'claimOffice.beneficiariesRequirement.requirements.close'
              | translate
          }}"
          margin="xxsmall"
          mode="secondary"
          (onClick)="onCloseDialog()"
        >
        </custom-button>
      </div>
    </div>
  </ng-container>

  <!--For Payment Details-->
  <ng-container *ngIf="paymentDetails">
    <div class="row">
      <div class="col-6">
        <p class="titleFont">
          {{ "processClaims.assessment.bankDetails.label" | translate }}
        </p>
      </div>
    </div>
    <div class="detail-container card mt-3 p-4">
      <!--SubTitle-->
      <div class="row">
        <div class="col-6">
          <p class="subTitleFont">
            {{
              "processClaims.assessment.bankDetails.PaymentDetails" | translate
            }}
          </p>
        </div>
      </div>
      <!--Form-->
      <div class="row">
        <!--Bank Acc No-->
        <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12 pl-xl-0 pl-lg-0">
          <div class="d-flex justify-content-end">
            <div class="col-lg-12 col-xl-12 col-md-12 col-sm-12 search-expan">
              <custom-input-text
                label="{{
                  'processClaims.assessment.bankDetails.bankDetails' | translate
                }}"
                [model]="bankPaymentDetails.bankKey"
                (valueChange)="onDataInputPaymentDetails($event, 'bankKey')"
              ></custom-input-text>
              <img
                class="search-icon"
                src="{{ searchicon }}"
                (click)="onCreateBankDetails()"
                alt=""
              />
            </div>
          </div>
        </div>
        <!--Bank Name-->
        <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12">
          <div class="d-flex justify-content-end">
            <div class="col-lg-12 col-xl-12 col-md-12 col-sm-12 search-expan">
              <custom-input-text
                label="{{
                  'processClaims.assessment.bankDetails.bankAccount' | translate
                }}"
              ></custom-input-text>
              <img class="search-icon" src="{{ searchicon }}" alt="" />
            </div>
          </div>
        </div>
        <!-- Add Bank Details Button-->
        <div
          class="col-xl-4 col-lg-4 col-md-6 col-sm-12 pr-xl-0 pr-lg-0 text-right"
        >
          <custom-button
            class="addButton"
            label="{{
              'processClaims.assessment.bankDetails.create' | translate
            }}"
            mode="secondary"
            [iconSrc]="addIcon"
            iconPosition="after"
            (onClick)="createNewBankDetails()"
[disabled]="!enableCreateNewBankDetails"
          >
          </custom-button>
        </div>
      </div>
      <!--Table For Payment Details-->
      <dxc-table class="table-responsive-sm dashabordTable mt-2">
        <tr class="header-filter tableHeader">
          <th id="select">
            {{ "processClaims.assessment.bankDetails.select" | translate }}
          </th>
          <th id="account">
            {{ "processClaims.assessment.bankDetails.account" | translate }}
          </th>
          <th id="accountType">
            {{ "processClaims.assessment.bankDetails.accountType" | translate }}
          </th>
          <th id="accountName">
            {{ "processClaims.assessment.bankDetails.accountName" | translate }}
          </th>
          <th id="currency">
            {{ "processClaims.assessment.bankDetails.currecncy" | translate }}
          </th>
        </tr>
        <tr class="table-header" *ngFor="let item of getBankData; index as i">
          <td>
            <span class="mobile-label">
              {{ "processClaims.assessment.bankDetails.select" | translate }}
            </span>
            <span>
              <dxc-radio></dxc-radio>
            </span>
          </td>
          <td>
            <span class="mobile-label">
              {{ "processClaims.assessment.bankDetails.account" | translate }}
            </span>
            <span>{{ item.summary.bankAccount }}</span>
          </td>
          <td>
            <span class="mobile-label">
              {{
                "processClaims.assessment.bankDetails.accountType" | translate
              }}
            </span>
            <span>{{ item.summary.bankAccountType }}</span>
          </td>
          <td>
            <span class="mobile-label">
              {{
                "processClaims.assessment.bankDetails.accountName" | translate
              }}
            </span>
            <span>{{ item.summary.bankAccountDec }}</span>
          </td>
          <td>
            <span class="mobile-label">
              {{ "processClaims.assessment.bankDetails.currecncy" | translate }}
            </span>
            <span>{{ item.summary.currcode }}</span>
          </td>
        </tr>
      </dxc-table>
    </div>

    <div class="row mt-5">
      <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 mobAction text-right">
        <custom-button
          label="{{
            'claimOffice.beneficiariesRequirement.requirements.save' | translate
          }}"
          margin="xxsmall"
          mode="primary"
          (onClick)="onCloseDialog()"
        >
        </custom-button>
      </div>
      <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 mobAction text-left">
        <custom-button
          label="{{
            'claimOffice.beneficiariesRequirement.requirements.close'
              | translate
          }}"
          margin="xxsmall"
          mode="secondary"
          (onClick)="onCloseDialog()"
        >
        </custom-button>
      </div>
    </div>
  </ng-container>

  <!--New Bank Details-->
  <ng-container *ngIf="newBankDetails">
    <div class="row">
      <div class="col-6">
        <p class="titleFont">
          {{ "processClaims.assessment.bankDetails.label" | translate }}
        </p>
      </div>
    </div>
    <div class="detail-container card mt-3 p-4">
      <!--SubTitle-->
      <div class="row">
        <div class="col-6">
          <p class="subTitleFont">
            {{
              "processClaims.assessment.bankDetails.newBankDetails" | translate
            }}
          </p>
        </div>
      </div>
      <!--Form-->
      <!--Row 1-->
      <div class="row">
        <!--Client No-->
        <div class="col-xl-3 col-lg-3 col-md-6 col-sm-12">
          <custom-input-text
            label="{{
              'processClaims.assessment.bankDetails.client' | translate
            }}"
            [model]="bankPaymentDetails.client"
            (valueChange)="onDataInputPaymentDetails($event, 'client')"
          ></custom-input-text>
        </div>
        <!--Client Name-->
        <div class="col-xl-3 col-lg-3 col-md-6 col-sm-12">
          <custom-input-text
            label="{{
              'processClaims.assessment.bankDetails.clientName' | translate
            }}"
            [model]="bankPaymentDetails.clientName"
            (valueChange)="onDataInputPaymentDetails($event, 'clientName')"
          ></custom-input-text>
        </div>
        <!--Bank Description-->
        <div class="col-xl-3 col-lg-3 col-md-6 col-sm-12">
          <custom-input-text
            label="{{
              'processClaims.assessment.bankDetails.bankDescription' | translate
            }}"
            [model]="bankPaymentDetails.bankdesc"
            (valueChange)="onDataInputPaymentDetails($event, 'bankdesc')"
          ></custom-input-text>
        </div>
        <!--Branch Description-->
        <div class="col-xl-3 col-lg-3 col-md-6 col-sm-12">
          <custom-input-text
            label="{{
              'processClaims.assessment.bankDetails.branchDescription'
                | translate
            }}"
            [model]="bankPaymentDetails.branchdesc"
            (valueChange)="onDataInputPaymentDetails($event, 'branchdesc')"
          ></custom-input-text>
        </div>
      </div>

      <!--Row 2-->
      <div class="row">
        <!--Factoring House-->
        <div class="col-xl-3 col-lg-3 col-md-6 col-sm-12">
          <custom-select
            label="{{
              'processClaims.assessment.bankDetails.factoringHouse' | translate
            }}"
            (valueChange)="onDataInputPaymentDetails($event, 'facthous')"
            [value]="bankPaymentDetails.facthous"
            [autoOptions]="factoringHouseList"
          ></custom-select>
        </div>
        <!--Account Number-->
        <div class="col-xl-3 col-lg-3 col-md-6 col-sm-12">
          <custom-input-text
            label="{{
              'processClaims.assessment.bankDetails.accountNo' | translate
            }}"
            (valueChange)="onDataInputPaymentDetails($event, 'bankAccount')"
            [value]="bankPaymentDetails.bankAccount"
          ></custom-input-text>
        </div>
        <!--Account Name-->
        <div class="col-xl-3 col-lg-3 col-md-6 col-sm-12">
          <custom-input-text
            label="{{
              'processClaims.assessment.bankDetails.accountName' | translate
            }}"
            (valueChange)="onDataInputPaymentDetails($event, 'bankAccountDec')"
            [value]="bankPaymentDetails.bankAccountDec"
          ></custom-input-text>
        </div>
        <!--Account Type-->
        <div class="col-xl-3 col-lg-3 col-md-6 col-sm-12">
          <custom-select
            label="{{
              'processClaims.assessment.bankDetails.accountType' | translate
            }}"
            (valueChange)="onDataInputPaymentDetails($event, 'bankAccountType')"
            [value]="bankPaymentDetails.bankAccountType"
            [autoOptions]="accountTypeList"
          ></custom-select>
        </div>
      </div>

      <!--Row 3-->
      <div class="row">
        <!--Security Code-->
        <div class="col-xl-3 col-lg-3 col-md-6 col-sm-12">
          <custom-input-text
            label="{{
              'processClaims.assessment.bankDetails.securityCode' | translate
            }}"
            (valueChange)="onDataInputPaymentDetails($event, 'sctycde')"
            [value]="bankPaymentDetails.sctycde"
          ></custom-input-text>
        </div>
        <!--Account Currency-->
        <div class="col-xl-3 col-lg-3 col-md-6 col-sm-12">
          <custom-select
            label="{{
              'processClaims.assessment.bankDetails.accountCurrency' | translate
            }}"
            (valueChange)="onDataInputPaymentDetails($event, 'currcode')"
            [value]="bankPaymentDetails.currcode"
            [autoOptions]="accountCurrencyList"
          ></custom-select>
        </div>
        <!--Current From-->
        <div class="col-xl-3 col-lg-3 col-md-6 col-sm-12">
          <custom-date-picker
            label="{{
              'processClaims.assessment.bankDetails.currentFrom' | translate
            }}"
            (valueChange)="onDataInputPaymentDetails($event, 'dateFrom')"
            [value]="bankPaymentDetails.dateFrom"
          ></custom-date-picker>
        </div>
        <!--Current To-->
        <div class="col-xl-3 col-lg-3 col-md-6 col-sm-12">
          <custom-date-picker
            label="{{
              'processClaims.assessment.bankDetails.currentTo' | translate
            }}"
            (valueChange)="onDataInputPaymentDetails($event, 'dattoDisp')"
            [value]="bankPaymentDetails.dattoDisp"
          ></custom-date-picker>
        </div>
      </div>
      <!--Row 4-->
      <div class="row">
        <!--Bank Branch Code/IBAN-->
        <div class="col-xl-3 col-lg-3 col-md-6 col-sm-12">
          <custom-input-text
            label="{{
              'processClaims.assessment.bankDetails.bankBranchCode' | translate
            }}"
            (valueChange)="onDataInputPaymentDetails($event, 'ibanaccno')"
            [value]="bankPaymentDetails.ibanaccno"
          ></custom-input-text>
        </div>
      </div>
    </div>

    <div class="row mt-5">
      <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 mobAction text-right">
        <custom-button
          label="{{
            'claimOffice.beneficiariesRequirement.requirements.save' | translate
          }}"
          margin="xxsmall"
          mode="primary"
          (onClick)="onSaveNewBankDetails()"
        >
        </custom-button>
      </div>
      <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 mobAction text-left">
        <custom-button
          label="{{
            'claimOffice.beneficiariesRequirement.requirements.close'
              | translate
          }}"
          margin="xxsmall"
          mode="secondary"
          (onClick)="onCloseNewBankDetails()"
        >
        </custom-button>
      </div>
    </div>
  </ng-container>
</div>
